module.exports = function(el) {
	if (location.hash) {
		var email = location.hash.replace('#', '');
		return $.ajax({
			type: 'GET',
			url: '/wp-json/crr/v1/queue/' + email,
			success: function (res) {
				if (res && res.result) {
					$('body').addClass('is-queue');
					$('.js-email').text(email);
					if (res.result.first_name) {
						$('.js-first-name').text(res.result.first_name);
					}
					if (res.result.last_name) {
						$('.js-last-name').text(res.result.last_name);
					}
					if (res.result.wait_time){
						$('.js-wait').text(res.result.wait_time);
					}
				}
			},
			dataType: 'json',
			async: false
		});
	}
};
